import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { post, errorMessage } from "@/api/client";
import { Button, Dialog, Input } from "@/ui";

// Shown whenever the server answers 428 step_up_required; the original request is retried after.
export function StepUpDialog({ open, onDone }: { open: boolean; onDone: (ok: boolean) => void }) {
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await post("/auth/step-up", { password, code: code.replace(/\s/g, "") });
      setPassword("");
      setCode("");
      onDone(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onDone(false)} title="Confirm it's you">
      <form className="stack" onSubmit={submit}>
        <p className="muted row"><ShieldCheck size={16} aria-hidden /> This action needs a fresh check. It stays unlocked for 5 minutes.</p>
        <Input label="Password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus required />
        <Input label="Authenticator code" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9 ]{6,7}" value={code} onChange={(e) => setCode(e.target.value)} required />
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        <div className="row" style={{ justifyContent: "flex-end" }}>
          <Button variant="ghost" onClick={() => onDone(false)}>Cancel</Button>
          <Button variant="primary" type="submit" loading={busy}>Confirm</Button>
        </div>
      </form>
    </Dialog>
  );
}
